/*
 * @Author: your name
 * @Date: 2022-04-01 20:46:01
 * @LastEditTime: 2022-04-09 14:56:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wap\src\components\global\index.js
 */
import Vue from 'vue'
import * as components from '@/components/global/global'
// Register global coponents
Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
})